module.exports = __webpack_public_path__ + "static/media/Ninja-victory.4d11e6a6.png";